<template>
  <div class="event-email-template-test">
    <h4>Send test-email</h4>
    <div class="row">
      <div class="mb-3 col-sm-3">
        <label class="form-label">E-mail template</label>
        <select
          v-model="templateId"
          class="form-select form-select-sm"
        >
          <option
            v-for="template in emailTemplates"
            :key="template.id"
            :value="template.id"
          >
            {{ template.name }}
          </option>
        </select>
      </div>
      <div class="mb-3 col-sm-3">
        <label class="form-label">Recipient</label>
        <input
          v-model="recipient"
          type="text"
          class="form-control form-control-sm"
        >
      </div>
    </div>
    <div class="row">
      <div class="col col-sm-12">
        <button
          type="button"
          class="btn btn-sm btn-success"
          :disabled="isLoading"
          @click.prevent="sendTestEmail"
        >
          Send test e-mail
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col col-6">
        <loading-indicator
          v-if="isLoading"
          message="Sending ..."
        />
        <alert
          v-if="message.show"
          :type="message.type"
          :message="message.text"
          :dismissable="false"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted} from "vue"
import axios from "axios"
import Rails from "@rails/ujs"
import Alert from "./alert.vue"
import LoadingIndicator from "./loading-indicator.vue"
import { isNonEmptyString } from "@/js/js-utils"

interface EmailTemplate {
  id: number;
  name: string;
}

const props = defineProps({
  emailTemplates: {default: null, type: Array as () => EmailTemplate[]},
  sendUrl: {default: null, type: String},
  defaultRecipient: {default: null, type: String}
})

const recipient = ref(props.defaultRecipient)
const isLoading = ref(false)
const templateId = ref<number | null>(null)
const message = ref({
  show: false,
  type: 'success',
  text: null as string | null
})

onMounted(() => {
  if (props.emailTemplates?.length > 0) {
    templateId.value = props.emailTemplates[0].id
  }
})

// Methods
const sendTestEmail = (): void => {
  message.value.show = false
  isLoading.value = true

  axios.post(props.sendUrl, {
    recipient: recipient.value,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    template_id: templateId.value
  }, {
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'X-Requested-With': 'XMLHttpRequest',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'X-CSRF-Token': Rails.csrfToken(),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Accept': 'application/json'
    }
  })
    .then((response) => {
      message.value.show = true
      message.value.type = 'success'
      message.value.text = isNonEmptyString(response.data.message) ? response.data.message : 'Test e-mail has been sent'
      isLoading.value = false
    })
    .catch((error) => {
      message.value.show = true
      message.value.type = 'danger'
      message.value.text = `Error: ${error.message}`
      isLoading.value = false
    })
}
</script>
